import PropTypes from 'prop-types'
import React from 'react'

const HostingIcon = ({
   className,
   color,
   width,
   height
}) => (
   <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24">
      <g
         className={className}
         fill={color}>
         <path
            d="M23,1H1A1,1,0,0,0,0,2v8a1,1,0,0,0,1,1H23a1,1,0,0,0,1-1V2A1,1,0,0,0,23,1ZM10,7H4V5h6Zm9,0a1,1,0,1,1,1-1A1,1,0,0,1,19,7Z"
         />
         <path
            d="M23,13H1a1,1,0,0,0-1,1v8a1,1,0,0,0,1,1H23a1,1,0,0,0,1-1V14A1,1,0,0,0,23,13ZM10,19H4V17h6Zm9,0a1,1,0,1,1,1-1A1,1,0,0,1,19,19Z"
         />
      </g>
   </svg>
)

HostingIcon.propTypes = {
   className: PropTypes.string,
   color: PropTypes.string,
   height: PropTypes.string,
   width: PropTypes.string
}

HostingIcon.defaultProps = {
   className: undefined,
   color: '#444',
   height: '24px',
   width: '24px'
}

export default React.memo(HostingIcon)
